import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';
import { WarehouseEntity } from './warehouse.entity';

@Index('fk_user__id', ['fkUserId'], {})
@Index('fk_warehouse__id', ['fkWarehouseId'], {})
@Entity('user_warehouse')
export class UserWarehouseEntity extends BaseEntity {
	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('int', { name: 'fk_warehouse__id', unsigned: true })
	public fkWarehouseId!: number;

	@ManyToOne(() => UserEntity, (user) => user.userWarehouses, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;

	@ManyToOne(() => WarehouseEntity, (warehouse) => warehouse.userWarehouses, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_warehouse__id', referencedColumnName: 'id' }])
	public fkWarehouse!: WarehouseEntity;
}
